import React from 'react';
import Chart from '../chart';
import { mergeOptions } from '../utils/commons';
import './css/commons.css';
import mergeRefs from 'react-merge-refs';
var treeMapOptions = _ref => {
  var {
    theme
  } = _ref;
  return {
    chart: {
      type: 'treemap'
    },
    plotOptions: {
      treemap: {
        dataLabels: {
          color: theme.palette.foreground.inverse,
          shadow: false,
          style: {
            fontSize: theme.typography.size0,
            fontWeight: 'normal',
            lineHeight: theme.typography.lineHeight1,
            textOutline: 'none'
          }
        }
      }
    },
    tooltip: {
      backgroundColor: theme.colorChartTooltipBackground,
      pointFormat: '{point.name}: {point.value}<br/>',
      shadow: false,
      style: {
        color: theme.colorChartTooltipForeground,
        fontSize: theme.typography.size0,
        fontWeight: 'normal',
        lineHeight: theme.typography.lineHeight1
      }
    }
  };
};
var TreeMap = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartRef = React.useRef();
  var handleRef = mergeRefs([ref, chartRef]);
  var chartOptions = React.useMemo(() => {
    return mergeOptions(treeMapOptions({
      theme
    }), options);
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    immutable: true,
    options: chartOptions,
    ref: handleRef,
    theme: theme
  });
});
TreeMap.displayName = 'TreeMap';
export default TreeMap;